import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id CE6EAE27-922A-48B9-83AF-5C333B20724F
 * name vector-triangle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-triangle.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorTriangleIcon = createSvgIcon(<><path d="M9,3V9H9.73L5.79,16H2V22H8V20H16V22H22V16H18.21L14.27,9H15V3M11,5H13V7H11M12,9.04L16,16.15V18H8V16.15M4,18H6V20H4M18,18H20V20H18" /></>, 'VectorTriangleIcon');
export default VectorTriangleIcon